import { createContext } from "react";
import enTranslations from "../locales/en.json";

export interface LangContextType {
  t: (key: string) => string;
  currentLang: string;
  changeLang: (lang: string) => void;
  isClient: boolean;
}

// Default context value for SSR safety
const defaultT = (key: string): string => {
  const keys = key.split(".");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let translation: any = enTranslations;

  for (const k of keys) {
    if (!translation[k]) return key;
    translation = translation[k];
  }
  return translation;
};

const defaultContextValue: LangContextType = {
  t: defaultT,
  currentLang: "en",
  changeLang: () => {},
  isClient: false,
};

export const LanguageContext =
  createContext<LangContextType>(defaultContextValue);
